import DeleteCategoryButton from "./DeleteCategoryButton";

export default DeleteCategoryButton;
